module.exports = __webpack_public_path__ + "media/native-apps/stockholmslan-debedc23.webp";